// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1816":"6be047972552748d","2235":"98fee7a82626b27e","3465":"284ebe54142071aa","5085":"93413891b36c93b3","5724":"807c5e7bf1cbe3bd","8385":"3825cf391941bf2a"}[chunkId] + ".js";
};